module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("Zquz9"))).then(() => parcelRequire('hEqeo'));